import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client";

import { addAuthVars } from "@teamrota/authlib";

export const VALIDATE_PAYROLL_RULE = addAuthVars(gql`
  mutation validatePayrollRule($name: String!, $config: [JSONObject]!) {
    validatePayrollRule(name: $name, config: $config)
  }
`);

export const useValidatePayrollRule = () => {
  const [update, { loading, error }] = useMutation(VALIDATE_PAYROLL_RULE, {
    onError: error => {
      throw error;
    }
  });
  const validatePayrollRule = async ({
    name,
    config
  }: {
    name: string;
    config: JSON;
  }) => {
    await update({
      variables: {
        name,
        config
      }
    });
  };

  return { validatePayrollRule, loading, error };
};
